import React from "react";

const Hero = () => {
  return (
    <div className="text-center pt-28 pb-12 px-6 bg-gradient-to-b from-white to-gray-50">
      <p className="font-popinsMedium text-sm uppercase tracking-widest text-paraColor mb-4">
        Simple, Transparent Pricing
      </p>
      <h1 className="text-4xl lg:text-6xl lg:tracking-[-3px] font-popinsBold text-themeColor leading-tight">
        Plans That Scale With <span className="text-btnColor">Your Portfolio</span>
      </h1>
      <p className="text-paraColor font-popinsMedium text-base lg:w-[42%] mx-auto pt-4 leading-relaxed">
        No hidden fees. No surprises. Just straightforward pricing designed for
        flex space operators — from single-site parks to multi-location portfolios.
      </p>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
        {["No credit card required", "Cancel anytime", "Setup in minutes", "Dedicated onboarding support"].map((badge) => (
          <span
            key={badge}
            className="flex items-center gap-1.5 text-xs font-popinsMedium text-paraColor bg-white border border-gray-200 rounded-full px-4 py-1.5 shadow-sm"
          >
            <span className="text-statusColor text-base">✓</span>
            {badge}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Hero;
